const dashboard = () => import(/* webpackPrefetch: true */ '@/views/private/internal/index.vue')

const service = () => import(/* webpackPrefetch: true */ '@/views/private/internal/service/index.vue')
const service_add = () => import(/* webpackPrefetch: true */ '@/views/private/internal/service/add/index.vue')
const service_edit = () => import(/* webpackPrefetch: true */ '@/views/private/internal/service/edit/_id.vue')
const service_quota = () => import(/* webpackPrefetch: true */ '@/views/private/internal/service/quota/_id.vue')

const invoice = () => import(/* webpackPrefetch: true */ '@/views/private/internal/invoice/index.vue')

const packages = () => import(/* webpackPrefetch: true */ '@/views/private/internal/package/index.vue')

const routes = [
  {
    path: "/internal/dashboard",
    name: "Dashboard Internal",
    component: dashboard,
    meta: {
      title: "Dashboard Internal"
    }
  },

  {
    path: "/internal/service",
    name: "Perusahaan",
    component: service,
    meta: {
      title: "Perusahaan"
    }
  },
  {
    path: "/internal/service/add",
    name: "Tambah Perusahaan",
    component: service_add,
    meta: {
      title: "Tambah Perusahaan"
    }
  },
  {
    path: "/internal/service/edit/:id",
    name: "Ubah Perusahaan",
    component: service_edit,
    meta: {
      title: "Ubah Perusahaan"
    }
  },
  {
    path: "/internal/service/quota/:id",
    name: "Quota Layanan",
    component: service_quota,
    meta: {
      title: "Quota Layanan"
    }
  },

  {
    path: "/internal/invoice",
    name: "Invoice",
    component: invoice,
    meta: {
      title: "Invoice"
    }
  },

  {
    path: "/internal/package",
    name: "Paket",
    component: packages,
    meta: {
      title: "Paket"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})